import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import BenefitsCrypto from '../../../components/video-production/explainer-videos/BenefitsCrypto';
import ProcessSliderCrypto from '../../../components/sliders/ProcessSliderCrypto';
import SolveProblemsCrypto from '../../../components/video-production/explainer-videos/SolveProblemsCrypto';

lazyload({
  width: '100%',
});

const ExplainerVideosCrypto = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Crypto Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/crypto-explainer-video" />
        <meta
          name="description"
          content="Unlock crypto intricacies with our concise crypto explainer videos. Simplify understanding. Elevate your knowledge. Start your journey with Prodigi"
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/crypto-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Crypto Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Unlock crypto intricacies with our concise crypto explainer videos. Simplify understanding. Elevate your knowledge. Start your journey with Prodigi"
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/crypto-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
  "@context": "http://schema.org",
  "@type": "WebPage",
  "name": "Video Production - Crypto Explainer Video | Prodigi",
  "description": "Unlock crypto intricacies with our concise crypto explainer videos. Simplify understanding. Elevate your knowledge. Start your journey with Prodigi",
  "url": "https://weprodigi.com/video-production/crypto-explainer-video",
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://weprodigi.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Full Service Video Production",
        "item": "https://weprodigi.com/video-production"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Crypto Explainer Video Production ",
        "item": "https://weprodigi.com/video-production/crypto-explainer-video"
      }
    ]
  },
  "mainEntity": {
    "@type": "Product",
    "name": "Crypto Explainer Video Production",
    "description": "Unlock crypto intricacies with our concise crypto explainer videos. Simplify understanding. Elevate your knowledge. Start your journey with Prodigi",
    "brand": {
      "@type": "Brand",
      "name": "Weprodigi"
    },
    "offers": {
      "@type": "Offer",
      "price": "1300",
      "priceCurrency": "USD",
      "seller": {
        "@type": "Organization",
        "name": "Weprodigi"
      }
    },
    "image": "https://weprodigi.com/images/logovertical.svg",
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Frank Clarke"
        },
        "datePublished": "2024-01-03",
        "reviewBody": "Prodigi's crypto explainer videos are simply outstanding! They effortlessly break down complex concepts into digestible chunks, making it easier for viewers to understand."
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Kate Williams"
        },
        "datePublished": "2024-03-21",
        "reviewBody": "Impressed by Prodigi's ability to convey intricate crypto topics in such a visually appealing and engaging manner. Their videos are a must-watch for anyone diving into the world of cryptocurrencies."
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "4.9",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Marcus Evans"
        },
        "datePublished": "2024-12-12",
        "reviewBody": "Prodigi's explainer videos on crypto are a game-changer! The clarity and simplicity they bring to the table are commendable. Kudos to the team for their excellent work."
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "3"
    }
  }
}`,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/crypto-explainer/crypto-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Crypto Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/crypto-explainer-video',
                name: 'Crypto Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  A crypto explainer video is a description of cryptocurrency that everyone needs. The animated financial videos create interest in
                  this fast-growing industry. It’s an effective way to keep everyone updated. Scroll down for more information.
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full lg:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What Is a Crypto Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/N0q6WBkVrb8?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Apaprika | Crypto Explainer Video</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                This industry still has a lot of questions. How can we build a better understanding of this innovation? A crypto explainer video can
                change everything. It will answer all the questions. Of course, it will simplify the information. And, of course, it will build trust
                in this industry.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  This industry still has a lot of questions. How can we build a better understanding of this innovation? A crypto explainer video can
                  change everything. It will answer all the questions. Of course, it will simplify the information. And, of course, it will build
                  trust in this industry.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use Crypto Explainer Videos?
            </h2>
            <p className={'mt-20'}>
              It’s time to set people free from getting lost in long pages! Make your content talk to your audience. It’s possible with an explainer
              video. Explore how to give simple answers to complex questions.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/Mmi_haEZyv8?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Simple Arbitrage | Crypto Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  How do you improve your crypto business? You need a new method for this new industry. Start with an explanation. And an explanation
                  becomes helpful with a marketing video. They will easily communicate with your target audience. The shareable format of videos can
                  take over the digital world in a short time. Simple information is the best call to action for your audience. Promote your business
                  effectively. Use crypto animation on various platforms and show your customers that there’s nothing hard about digital currency.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    How do you improve your crypto business? You need a new method for this new industry. Start with an explanation. And an
                    explanation becomes helpful with a marketing video. They will easily communicate with your target audience. The shareable format
                    of videos can take over the digital world in a short time. Simple information is the best call to action for your audience.
                    Promote your business effectively. Use crypto animation on various platforms and show your customers that there’s nothing hard
                    about digital currency.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Financial Technology</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  Finance brings many challenges. One of the most challenging things regarding finances is confidence. But confidence can’t come by
                  itself. Blockchain explainer videos are coming to the rescue! They turn complex financial subjects into eye-catching visuals.
                  Explain how to buy, sell, and trade cryptocurrencies on your platforms. Illustrate how to use digital wallets to store and transact
                  crypto. Make an impact with an easy explanation.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Finance brings many challenges. One of the most challenging things regarding finances is confidence. But confidence can’t come by
                    itself. Blockchain explainer videos are coming to the rescue! They turn complex financial subjects into eye-catching visuals.
                    Explain how to buy, sell, and trade cryptocurrencies on your platforms. Illustrate how to use digital wallets to store and
                    transact crypto. Make an impact with an easy explanation.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/1fl7dK-llas?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Apaprika | Crypto Explainer Video</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/GcfJTZiAmd4?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Status Cards | Financial Product Explainer</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16 hidden md:block'}>
                  It’s easy to get bored of finance-related topics. And there’s always a need for something new in learning methods. Improve your
                  learning strategies by turning long descriptions into an animated explainer video. With an explainer video cryptocurrencies and
                  blockchain are simple. Also, it will keep your audience interested. It’s an essential addition to your public education campaigns.
                  Visual content will tell about crypto benefits and risks. As a result, it will help to protect customers. The uses of crypto
                  explainer videos in education are endless. It’s not rocket science anymore!
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    It’s easy to get bored of finance-related topics. And there’s always a need for something new in learning methods. Improve your
                    learning strategies by turning long descriptions into an animated explainer video. With an explainer video cryptocurrencies and
                    blockchain are simple. Also, it will keep your audience interested. It’s an essential addition to your public education campaigns.
                    Visual content will tell about crypto benefits and risks. As a result, it will help to protect customers. The uses of crypto
                    explainer videos in education are endless. It’s not rocket science anymore!
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of Crypto Explainer Videos
            </h2>
            <p className={'mt-20'}>
              What benefits can crypto animation video have? A simple explanation is the key, but that’s not all. Scroll down to know the main
              benefits.
            </p>
            <Suspense fallback={`Loading...`}>
              <BenefitsCrypto />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our Crypto Explainer Video Production Process
            </h2>
            <ProcessSliderCrypto />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-26 lg:text-36'
              }
            >
              CALCULATE YOUR CRYPTO EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Crypto Explainer Video Can Help Your Business?
            </h2>
            <p className={'mt-20'}>
              Hard to imagine recent marketing campaigns without explainer videos. Choose the most convenient way to promote your new-generation
              business.
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsCrypto />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Crypto Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We value your time.',
                  answer:
                    "We know how important our clients' time is. Outsourcing full-service video production helps save your expensive time. More importantly, we quickly understand your business needs and implement our proven time-saving solutions at all stages of production, from communication to payment methods.",
                },
                {
                  title: 'We include digital marketing specialists in the production process.',
                  answer:
                    "According to Google, 6 out of 10 people prefer watching videos online rather than TV. To create an effective video, you need to consider which platform the video will be used on and master all its features, be it your website, YouTube, Facebook, or Amazon. That's why we include our digital marketing specialists in the production process, who study your business requirements in detail and combine them with the requirements of each online platform to get effective material.",
                },
                {
                  title: "We don't require prepayment.",
                  answer:
                    "The client should pay for the work rather than with deposits. We chose a milestone payment option as it's a more trustworthy approach to our work.",
                },
                {
                  title: "We don't have a single unhappy client.",
                  answer:
                    'We never charge for a product that you have not approved. If you are unsatisfied with the results, 100% money-back is guaranteed.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'What is a blockchain explainer video?',
                    answer:
                      'A blockchain explainer video is a short, engaging, and educational video for explaining the concept of blockchain technology in an understandable way. ',
                  },
                  {
                    title: 'What topics are typically covered in a Crypto Explainer Video?',
                    answer: 'In a crypto explainer video are covered various aspects of cryptocurrency and blockchain technology. ',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'Who is the target audience for Crypto Explainer Videos?',
                    answer:
                      'The target audience for crypto explainer videos is diverse, reflecting the broad appeal and wide-ranging applications. Crypto animation videos are made to provide information to various audiences.',
                  },
                  {
                    title: 'Are Crypto Explainer Videos only for educational purposes, or can they also be promotional? ',
                    answer: 'The flexible format of crypto explainer videos allows to make explainer videos for different purposes.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosCrypto;
